export const CPT = {
  navCpt: "nav-cpt",
  page: "cpt-page",
  title: "cpt-title",
  banner: "cpt-reference-banner",
  table: "cpt-table",
  loading: "cpt-loading",
  emptyState: "cpt-empty",
  errorState: "cpt-error",
  row: "cpt-row",
};
